import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useTiktokShopWarehousesQuery = createQueryHook(
  CreatorIntegrationsApiClient.getTiktokPartnerWarehouses,
  {
    queryKey: ['tiktokShopWarehouses'],
  },
)
